module.exports = __webpack_public_path__ + "img/qr-code.761cf89.png";